import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoginRequest, LoginResponse } from '../../../core/models/auth.model';
import { ApiEndpoints } from '../../../core/api/api-endpoints';

export interface ForgotPasswordRequest {
  email: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface ResetPasswordValidateResponse {
  email: string;
  fullName: string;
}

export interface ResetPasswordRequest {
  email: string;
  code: string;
  newPassword: string;
  confirmPassword: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = ApiEndpoints.auth;

  login(credentials: LoginRequest) {
    return this.http.post<LoginResponse>(this.apiUrl, credentials);
  }

  refresh(refreshToken: string) {
    return this.http.post<LoginResponse>(ApiEndpoints.authRefresh, { refreshToken });
  }

  forgotPassword(request: ForgotPasswordRequest) {
    return this.http.post<ForgotPasswordResponse>(`${this.apiUrl}/forgot-password`, request);
  }

  validateResetPassword(email: string, code: string) {
    return this.http.get<ResetPasswordValidateResponse>(`${this.apiUrl}/reset-password/validate`, {
      params: { email, code },
    });
  }

  resetPassword(request: ResetPasswordRequest) {
    return this.http.post<void>(`${this.apiUrl}/reset-password`, request);
  }
}
